import type { ReactNode } from 'react';
import { Button } from './button';
import { Modal } from './modal';

/**
 * DESIGN.md §6 DeleteConfirm generalised: sentence, optional warning, inline error,
 * Cancel (secondary) + confirm (destructive by default). Busy swaps the label.
 */
export function ConfirmDialog({
  open,
  onClose,
  title,
  body,
  warning,
  error,
  confirmLabel,
  busyLabel,
  cancelLabel,
  closeLabel,
  busy,
  tone = 'destructive',
  onConfirm,
}: {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  body: ReactNode;
  warning?: ReactNode;
  error?: ReactNode;
  confirmLabel: string;
  busyLabel: string;
  cancelLabel: string;
  closeLabel: string;
  busy: boolean;
  tone?: 'destructive' | 'primary';
  onConfirm: () => void;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      closeLabel={closeLabel}
      size="sm"
      dismissible={!busy}
      footer={
        <>
          <Button onClick={onClose} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button variant={tone} onClick={onConfirm} disabled={busy}>
            {busy ? busyLabel : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm">{body}</p>
      {warning ? <p className="mt-2 text-sm text-[var(--warning)]">{warning}</p> : null}
      {error ? (
        <div role="alert" className="mt-3 text-sm text-[var(--negative)]">
          {error}
        </div>
      ) : null}
    </Modal>
  );
}
